import React, {useState} from 'react'
import {
  ButtonBox,
  StyledDialog,
  DialogBox,
  DialogText,
  DialogTitle,
  StyledCloseIcon,
  SelectionBox,
  Selection,
  SelectionTitle,
  SelectionText,
} from './styles'
import {Button} from '../button'

type Props = {
  open: boolean
  setOpen: (value: boolean) => void
  onStartExam: (accommodationRate: number) => void
}

const View = ({open, setOpen, onStartExam}: Props) => {
  const [isSecondStep, setIsSecondStep] = useState(false)
  const [accommodationRate, setAccommodationRate] = useState(0)

  const handleClose = () => {
    setOpen(false)
    setIsSecondStep(false)
    setAccommodationRate(0)
  }

  return (
    <StyledDialog maxWidth={'md'} onClose={handleClose} open={open}>
      <DialogBox>
        <DialogTitle>
          {isSecondStep
            ? 'Choose your Accommodation'
            : 'Ready to Begin Your Practice Exam?'}
          <StyledCloseIcon
            onClick={handleClose}
            className="x-button"
            style={{
              height: 32,
              width: 32,
              cursor: 'pointer',
            }}
          />
        </DialogTitle>
        {isSecondStep ? (
          <SelectionBox>
            <Selection
              $isActive={accommodationRate === 20}
              onClick={() => setAccommodationRate(20)}
            >
              <SelectionTitle>ESL</SelectionTitle>
              <SelectionText>English as a Second Language</SelectionText>
              <br />
              <SelectionText>20% Time Accommodation</SelectionText>
              <SelectionText>(e.g., 60 min becomes 72min.)</SelectionText>
            </Selection>
            <Selection
              $isActive={accommodationRate === 50}
              onClick={() => setAccommodationRate(50)}
            >
              <SelectionTitle>ADA</SelectionTitle>
              <SelectionText>Americans with Disabilities Act</SelectionText>
              <br />
              <SelectionText>50% Time Accommodation</SelectionText>
              <SelectionText>(e.g., 60 min becomes 90min.)</SelectionText>
            </Selection>
          </SelectionBox>
        ) : (
          <DialogText>
            NCARB provides extra exam time for candidates with ESL needs,
            disabilities, or temporary medical conditions like pregnancy or
            breastfeeding. If eligible, click Start Exam with Accommodations.
            <br />
            Refer to the{' '}
            <a
              href="https://www.ncarb.org/sites/default/files/ARE-5-Guidelines.pdf"
              target="_blank"
            >
              ARE 5.0 Guidelines.
            </a>{' '}
            for details.
            <br />
            Choose your setup below to begin.
          </DialogText>
        )}
        <ButtonBox $isCentered={isSecondStep}>
          {isSecondStep ? (
            <Button
              disabled={accommodationRate === 0}
              onClick={() => onStartExam(accommodationRate)}
              children={'Start Exam'}
              color={'secondary'}
              size={'large'}
            />
          ) : (
            <>
              <Button
                onClick={() => onStartExam(0)}
                children={'Start Exam'}
                color={'secondary'}
                size={'large'}
              />
              <Button
                onClick={() => setIsSecondStep(true)}
                children={
                  <div style={{display: 'flex', flexFlow: 'column'}}>
                    Start Exam
                    <span style={{fontSize: '12px'}}>With Accommodations</span>
                  </div>
                }
                color={'primary'}
                size={'large'}
              />
            </>
          )}
        </ButtonBox>
      </DialogBox>
    </StyledDialog>
  )
}

export default View
